var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8616 3.62393L18.9743 17.3864H27.5376C28.5316 17.3864 29.4491 17.998 29.8314 18.9155C30.1372 19.9095 29.9078 20.9799 29.1432 21.668L9.56999 38.7946C8.65249 39.4828 7.42916 39.5592 6.51166 38.8711C5.59417 38.2594 5.21188 37.0361 5.67062 35.9657L11.5579 22.2032H3.07105C2.00064 22.2032 1.08314 21.5916 0.777308 20.6741C0.395018 19.6801 0.624392 18.6097 1.38897 17.9216L20.9622 0.794977C21.8797 0.106855 23.1031 0.0303968 24.0206 0.718519C24.9381 1.33018 25.3203 2.55351 24.8616 3.62393Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/electric.68a4812d1d11fe0ca2ae3bea2e5f99f2.svg";
export { ForwardRef as ReactComponent };